import React, { useState, useEffect, createRef, useRef, useContext } from "react";
import Submenu from "./Submenu";
import useSiteData from '../../useSiteData'
import { HeaderThemeContext, headerThemes } from "../../context";
import Icon from "../atoms/Icon";
import { isSubmenuActive } from "../../util/navigation";
import LinkButton from "../atoms/LinkButton";

export default () => {
    const { submenus, blogCategories } = useSiteData().navigationPrimary;
    const submenuElement = createRef();
    const activeNavButton = useRef(null);
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const [, requestUpdate] = useState();

    const handleClickOutside = event => {
        if (submenuElement.current && !submenuElement.current.contains(event.target) && activeSubmenu &&
            (!activeNavButton.current.contains(event.target))) {
            setActiveSubmenu(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    });

    const { theme } = useContext(HeaderThemeContext);
    const filteredSubmenus = submenus.filter(menu => menu.navigationGroups || menu.page);

    return (
        <div className="o-navigation-primary">
            {
                filteredSubmenus
                .map((menu, index) => {
                    const isSelected = menu === activeSubmenu;

                    const isActive = isSubmenuActive(menu);
                    const directLink = (!menu.navigationGroups && menu.page) ? menu.page.slug : undefined;

                    return (
                        <div className="o-navigation-primary__item" key={ index }>
                            <LinkButton
                                className={
                                    "o-navigation-primary__btn" +
                                    (theme === headerThemes.DARK ? " o-navigation-primary__btn--dark" : "") +
                                    (isSelected || isActive ? " o-navigation-primary__btn--selected" : "")
                                }
                                key={ index }
                                onClick={ () => {
                                    if( !directLink ) {
                                        setActiveSubmenu(isSelected ? null : menu)
                                    } else {
                                        requestUpdate()
                                    }
                                } }
                                url={ directLink }
                                ref={ isSelected ? activeNavButton : null }
                            >
                                { menu.title }
                                { index + 1 === filteredSubmenus.length &&
                                <Icon className="o-navigation-primary__icon a-icon a-icon--s" iconName="icon-menu"/>
                                }
                            </LinkButton>
                            {
                                isSelected &&
                                <Submenu
                                    onLinkClick={ () => {
                                        setActiveSubmenu(null)
                                    }}
                                    ref={ submenuElement }
                                    { ...activeSubmenu }
                                    blogCategories={ blogCategories }
                                />
                            }
                        </div>
                    );
                })
            }
        </div>
    );
};
